import { SET_POLICY, SET_POLICY_KIND_INVESTMENT, SET_CHANGEITEMS_RESULT, RESET_CHANGEITEMS_RESULT } from './mutations';

export const actions = {
    setPolicy({ commit }, payload) {
        commit(SET_POLICY, payload);
    },
    resetPolicy({ commit }) {
        commit(SET_POLICY_KIND_INVESTMENT, '');
        commit(SET_POLICY, {});
    },
    setPolicyKindInvestment({ commit }, payload) {
        commit(SET_POLICY_KIND_INVESTMENT, payload);
    },

    setChangeItemsResult({ commit }, payload) {
        commit(SET_CHANGEITEMS_RESULT, payload);
    },

    resetChangeItemsResult({ commit }) {
        commit(RESET_CHANGEITEMS_RESULT, {});
    },

};
